<template>
  <div>
    <div id="main-wrapper">
      <NoSideBarMain />
    </div>
  </div>
</template>

<script>
import NoSideBarMain from "@/components/Layout/NoSideBarMain";

export default {
  name: "LayoutNoSidebar",
  components: {
    NoSideBarMain,
  },

  data() {
    return {};
  },
};
</script>
